/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import {ReactComponent as NextIcon} from 'assets/svgs/pagination/next.svg';
import {ReactComponent as PrevIcon} from 'assets/svgs/pagination/last.svg';
import {DebounceInput} from 'react-debounce-input';
import 'styles/pagination.scss';

const Pagination = ({size, page, step, className, sequel, onChange}) => {
  const [data, setData] = useState({
    size: size || 0,
    page: page || 1,
    step: step || 1,
  });

  useEffect(() => {
    setData({
      size: size || 1,
      page: page || 1,
      step: step || 1,
    });
  }, [size]);

  const firstPage = () => (
    <>
      <li className={`${sequel ? 'page-item' : ''}`}>
        <a
          onClick={(e) => {
            e.preventDefault();
            setPage(1);
          }}
          href="#test"
          className={`${sequel ? 'item-link' : ''}`}
        >
          1
        </a>
      </li>
      <li className={`${sequel ? 'page-item' : ''}`}>
        {displayInput ? (
          <DebounceInput
            minLength={1}
            type="number"
            debounceTimeout={250}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                let pageNumber = parseInt(e.target.value, 10);
                if (pageNumber > size) {
                  pageNumber = size;
                }
                setPage(pageNumber);
                setDisplayInput(false);
              }
            }}
          />
        ) : (
          <i aria-hidden onClick={() => setDisplayInput(true)}>
            ...
          </i>
        )}
      </li>
    </>
  );
  const getPages = (s, f) => {
    const list = [];
    for (let i = s; i < f; i += 1) {
      list.push(i);
    }

    return list.map((singlePage) => (
      <li
        className={`${sequel ? 'page-item' : ''} ${
          singlePage === data.page ? 'active' : ''
        }`}
        key={singlePage}
      >
        <a
          onClick={(e) => {
            e.preventDefault();
            setPage(singlePage);
          }}
          href="#test"
          className={`${sequel ? 'item-link' : ''}`}
        >
          {singlePage}
        </a>
      </li>
    ));
  };

  const [displayInput, setDisplayInput] = useState(false);

  const lastPage = () => (
    <>
      <li className={`${sequel ? 'page-item' : ''}`}>
        {sequel ? (
          <a>
            {displayInput ? (
              <DebounceInput
                minLength={1}
                type="number"
                debounceTimeout={250}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    let pageNumber = parseInt(e.target.value, 10);
                    if (pageNumber > size) {
                      pageNumber = size;
                    }
                    setPage(pageNumber);
                    setDisplayInput(false);
                  }
                }}
              />
            ) : (
              <i aria-hidden onClick={() => setDisplayInput(true)}>
                ...
              </i>
            )}
          </a>
        ) : (
          <>
            {displayInput ? (
              <DebounceInput
                minLength={1}
                type="number"
                debounceTimeout={250}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    let pageNumber = parseInt(e.target.value, 10);
                    if (pageNumber > size) {
                      pageNumber = size;
                    }
                    setPage(pageNumber);
                    setDisplayInput(false);
                  }
                }}
              />
            ) : (
              <i aria-hidden onClick={() => setDisplayInput(true)}>
                ...
              </i>
            )}
          </>
        )}
      </li>
      <li className={`${sequel ? 'page-item' : ''}`}>
        <a
          href="#test"
          onClick={(e) => {
            e.preventDefault();
            setPage(data.size);
          }}
          className="item-link"
        >
          {data.size}
        </a>
      </li>
    </>
  );

  const setPage = (newPage) => {
    // if (newPage === data.page) return;

    const newData = {...data};
    newData.page = newPage;
    setData(newData);
    onChange(newPage);
  };

  const render = () => {
    if (data.size < data.step * 2 + 6) {
      return getPages(1, data.size + 1);
    }
    if (data.page < data.step * 2 + 1) {
      return (
        <>
          {getPages(1, data.step * 2 + 4)} {lastPage()}
        </>
      );
    }
    if (data.page > data.size - data.step * 2) {
      return (
        <>
          {firstPage()} {getPages(data.size - data.step * 2 - 2, data.size + 1)}
        </>
      );
    }
    return (
      <>
        {firstPage()}
        {getPages(data.page - data.step, data.page + data.step + 1)}
        {lastPage()}
      </>
    );
  };

  const next = () => {
    if (data.page === data.size) return;

    setPage(data.page + 1);
  };

  const prev = () => {
    if (data.page === 1) return;
    setPage(data.page - 1);
  };

  return (
    <ul className={`${className || ''}`}>
      {sequel ? (
        <li className="page-item next-page">
          <a
            href="#test"
            className="item-link"
            onClick={(e) => {
              e.preventDefault();
              prev();
            }}
          >
            <PrevIcon />
          </a>
        </li>
      ) : (
        <span aria-hidden onClick={prev}>
          <PrevIcon />
        </span>
      )}
      {render()}

      {sequel ? (
        <li className="page-item prev-page">
          <a
            href="#test"
            className="item-link"
            onClick={(e) => {
              e.preventDefault();
              next();
            }}
          >
            <NextIcon />
          </a>
        </li>
      ) : (
        <span aria-hidden onClick={next}>
          <NextIcon />
        </span>
      )}
    </ul>
  );
};

export default Pagination;
